import { render, staticRenderFns } from "./StudentClassAuditAddEdit.vue?vue&type=template&id=e4d7b288"
import script from "./StudentClassAuditAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassAuditAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports